export const API_URL = process.env.REACT_APP_DEPLOY === 'production' ? process.env.REACT_APP_API_URL_PRODUCTION : process.env.REACT_APP_API_URL;
export const PER_PAGE = 10;
